/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalSubmissionPresetCounts } from './PalSubmissionPresetCounts';
import {
    PalSubmissionPresetCountsFromJSON,
    PalSubmissionPresetCountsFromJSONTyped,
    PalSubmissionPresetCountsToJSON,
    PalSubmissionPresetCountsToJSONTyped,
} from './PalSubmissionPresetCounts';

/**
 * 
 * @export
 * @interface FindPalSubmissionPresetCounts200Response
 */
export interface FindPalSubmissionPresetCounts200Response {
    /**
     * 
     */
    data?: PalSubmissionPresetCounts;
}

/**
 * Check if a given object implements the FindPalSubmissionPresetCounts200Response interface.
 */
export function instanceOfFindPalSubmissionPresetCounts200Response(value: object): value is FindPalSubmissionPresetCounts200Response {
    return true;
}

export function FindPalSubmissionPresetCounts200ResponseFromJSON(json: any): FindPalSubmissionPresetCounts200Response {
    return FindPalSubmissionPresetCounts200ResponseFromJSONTyped(json, false);
}

export function FindPalSubmissionPresetCounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindPalSubmissionPresetCounts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalSubmissionPresetCountsFromJSON(json['data']),
    };
}

export function FindPalSubmissionPresetCounts200ResponseToJSON(json: any): FindPalSubmissionPresetCounts200Response {
    return FindPalSubmissionPresetCounts200ResponseToJSONTyped(json, false);
}

export function FindPalSubmissionPresetCounts200ResponseToJSONTyped(value?: FindPalSubmissionPresetCounts200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalSubmissionPresetCountsToJSON(value['data']),
    };
}

